import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';
import 'core-js/es/symbol';
import 'core-js/es/object';
import React from "react";
import ReactDOM from "react-dom";
import './index.css';

import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'
import {store} from './redux/store/ReduxStore'
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "./App";
import Company from "./components/Company.Component";
import Stage from "./components/Stage.Component";
import Application from "./components/Application.Component";


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App/>}>
                    <Route path={":companyId"} element={<Company/>}>
                        <Route path={":stage"} element={<Stage/>}>
                            <Route path={":application"} element={<Application/>}>
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    </Provider>
    ,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
